import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/allocation';
import types from 'constants/actionTypes';

export const fetchSeriesAllocation = createThunk({
  apiCall: backendAPI.getSeriesAllocation,
  type: types.GET_DEALERSHIP_ALLOCATION_REQUEST,
});
